const video = document.querySelector(".header-video__iframe");

if (video) {
    updateVideoWidth();
    window.addEventListener("resize", () => {
        window.requestAnimationFrame(updateVideoWidth);
    });
}

function updateVideoWidth() {
    if (window.innerWidth > (video.parentElement.scrollHeight / 9) * 16) {
        video.style.width = "100%";
    } else {
        video.style.width = "";
    }
}
